import { Result } from './interfaces/result';
import { Options } from './interfaces/options';
import { Component, OnInit, OnChanges, DoCheck, SimpleChanges, Input, EventEmitter, Output, forwardRef, ElementRef, Inject, ViewEncapsulation, HostListener, ViewChild, ViewContainerRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { AddressService } from './address.service';
import { ElementDef } from '@angular/core/src/view';
import { OverlayConfig, Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
declare const require: any;

/**
 * 城市选择器组件
 * Usage:
 * <ngx-address [(ngModel)]="city.id" [options]="{...}"></ngx-address>
 */
@Component({
    selector: 'ngx-address',
    template: `<div class="ngx-address" [offClick]="onClose">
    <div class="ngx-address-title" [ngClass]="{'has':_t.title.length > 0, 'red':isRequired}"
        (click)="onOpen($event)" #addressTitle>
        <span [innerHTML]="_t.title ? _t.title : options.placeholder"></span>
        <i class="arrow"></i>
    </div>
    <div class="ngx-address-overlay" *ngIf="_t.inited" [hidden]="!_t.opened" [ngStyle]="{'top.px': options.offset.y,'left.px': options.offset.x}" #layoutModal>
    <div class="ngx-address-select-warp">
        <div class="fx-address-search-group">
            <input id="searchAddress" class="fx-address-search-input" placeholder="搜索" (input)="onSearch($event)"/>
            <i class="anticon anticon-search fx-search-icon"></i>
        </div>
        <div class="ngx-address-select-tab">
<!--                <a *ngFor="let item of _t.hd" [style.display]="(item.name === '国家') ? 'none': 'block'" (click)="onTabChange(item.index)" [ngClass]="{'current': item.selected}">{{item.name}}</a>-->
            <a *ngFor="let item of _t.hd" (click)="onTabChange(item.index)" [ngClass]="{'current': item.selected}">{{item.name}}</a>
        </div>
        <div style="display: flex;">
            <div class="fx-anchor-content" style="">
                <a class="fx-anchor-item" [ngStyle]="{'visibility': anchorItem ? 'visible' : 'hidden'}" *ngFor="let anchorItem of anchorList"
                            (click)="scrollToAnchor(anchorItem)"
                            [ngClass]="{'selected': anchorItem == currentAnchor}"
                            >{{anchorItem}}</a>
            </div>          
            <div style ="flex: 1;" class="ngx-address-select" *ngFor="let bitem of _t.bd" [hidden]="!bitem.selected">
                <dl id="{{g.key}}" *ngFor="let g of bitem.data.items | keys">
                    <dt [ngClass]="{'selected': g.key == currentAnchor}" *ngIf="g.key">{{g.key}}</dt>
                    <dd>
                        <a *ngFor="let i of g.value"
                            (click)="onItem(bitem.index, g.key, i.id, i)"
                            [ngClass]="{'current': i.selected}" title="{{i.name}}" data-id="{{i.id}}"
                            href="javascript:;">{{i.name}}</a>
                    </dd>
                </dl>
                <dl class="ngx-address-tips" *ngIf="bitem.data.tips && bitem.data.tips.length > 0">
                    <dd>
                        <p *ngFor="let ti of bitem.data.tips" data-id="{{ti.id}}">{{ti.name}}</p>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</div>
</div>`,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./address.less'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => AddressComponent),
        multi: true
    }],
    host: {
        '[attr.class]': 'options.className'
    }
})
export class AddressComponent implements OnInit, OnChanges, ControlValueAccessor {

    @Input()
    public options: Options;

    @Input()
    public values: any;

    @Output()
    public onSelected: EventEmitter<Result> = new EventEmitter();

    @ViewChild('layoutModal') layoutModal: ElementRef;
    @ViewChild('addressTitle') addressTitle: ElementRef;

    public _t: AddressService;
    public isOpen = false;
    public isRequired = true;
    public glike = ''; // 模糊搜索
    public anchorList = []; // 锚点分组
    public currentAnchor = ''; // 记录当前锚点

    constructor(@Inject(ElementRef) public element: ElementRef) {
        this.onClose = this.onClose.bind(this);
        this._t = new AddressService();
    }

    ngOnInit(): void {
        console.log('address values', this.values);
        console.log('address options', this.options);
        if (Array.isArray(this.values)) {
            this._t.setAddress(this.values);
        }
        // this._t.getCity.subscribe(val => {
        //     if(val == "close") {
        //         this.element.nativeElement.ownerDocument.body.removeChild(this.layoutModal.nativeElement)
        //     }
        // })
    }

    onOpen(event) {
        // let a = this.element.nativeElement.ownerDocument.body.clientWidth/2;
        // let b = this.addressTitle.nativeElement.clientWidth/2,
        // c = a - b;
        // this.layoutModal.nativeElement.style['display'] = 'block';
        //     console.log(this.element,'onOpen')
        //     //this._t.opened = true;
        //     let x = event.clientX;
        //     let y = event.clientY;
        //     let setW = this.addressTitle.nativeElement.clientWidth;
        //     this.layoutModal.nativeElement.style['width'] = setW + 'px';
        //     this.layoutModal.nativeElement.style['left'] = (c + 36) + 'px';
        //     this.layoutModal.nativeElement.style['top'] = 161 + 'px';
        //     //document.body.append(this.layoutModal.nativeElement);
        //     this.element.nativeElement.ownerDocument.body.append(this.layoutModal.nativeElement);
        this._t.opened = true;
        this.getAnchorList();
    }

    onClose() {
        this._t.opened = false;
    }

    // 模糊搜索
    onSearch(e) {        
        // setTimeout(() => {
            this._t.bdAll.forEach((s, idx) => {
                if (s.selected) {
                    this._t.bd[idx].data.items = {};
                    for(var key in s.data.items) {
                        const items = s.data.items[key].filter(t => {
                            return !e.data || t.name.indexOf(e.data) !== -1;
                        }); 
                        if (items.length) {
                            this._t.bd[idx].data.items[key] = JSON.parse(JSON.stringify(items));
                        }                         
                    }
                }
            })
            this.getAnchorList();
        // }, 0);
    }

    onTabChange(index: number) {
        this._t.bd.forEach((s, idx) => {
            if (idx !== index) {
                this.glike = '';
                document.getElementById('searchAddress').innerText = '';
                if (this._t.bdAll[idx].data && this._t.bdAll[idx].data.items) {
                    s.data.items = JSON.parse(JSON.stringify(this._t.bdAll[idx].data.items));
                }
            }
        })
        this._t.setHead(index);
        this._t.opened = true;
        console.log(index, 'onTabChange')
        this.getAnchorList();
    }

    private notify() {
        this.onTouched();
        this.onChange(this._t.result.id);
        if (this.options && this._t.result.paths.length > 0) {
            var msgArr = ['国家', '省', '市', '区县', '街道', '小区'];
            if (this.options.types[0] == '国家') {
                this.isRequired = this._t.result.paths.length < Number(this.options.required_index);
                this._t.result.msg = this.isRequired ? '请选择' + msgArr[Number(this.options.required_index) - 1] : '';
            } else {
                this.isRequired = this._t.result.paths.length - 1 < Number(this.options.required_index);
                this._t.result.msg = this.isRequired ? '请选择' + msgArr[Number(this.options.required_index) - 2] : '';
            }
        } else {
            this.isRequired = false;
            this._t.result.msg = '';
        }
        this.onSelected.emit(this._t.result);
    }

    onItem(bdIndex: number, key: string, id: string, item: any) {
        this._t.onSelected(bdIndex, id, item);
        this.notify();
        //this.isOpen = false;
        console.log(item, this._t, 'onItem')
        setTimeout(() => {
            this.getAnchorList();
        }, 300);
    }

    // 获取分组数据
    getAnchorList() {
      // list分组，分组的第一笔数据保留bah003,其他清空
      this.anchorList = [];
      this._t.bd.forEach(s => {
        if (s.selected) {       
            for(var key in s.data.items) {
                this.anchorList.push(key);             
            }
        }
      })
    }
  
    // 点击锚点跳转定位
    scrollToAnchor(item) {
        this.currentAnchor = item;
        document.getElementById(this.currentAnchor).scrollIntoView({ behavior: 'smooth' });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.options) {
            this.options = this._t.initData(this.options);
            this.notify();
            return;
        }
        if (changes.values) {
            setTimeout(() => {
                this._t.setAddress(changes.values.currentValue);
            });
        }
    }

    writeValue(obj: any): void {
        if (obj && obj !== this._t.result.id) {
            setTimeout(() => {
                this._t.setAddress(obj);
            });
        }
    }

    protected onChange: any = Function.prototype;
    protected onTouched: any = Function.prototype;

    public registerOnChange(fn: (_: any) => {}): void { this.onChange = fn; }
    public registerOnTouched(fn: () => {}): void { this.onTouched = fn; }

    setDisabledState(isDisabled: boolean): void {
    }

}
